import styled from 'styled-components';
import { Button } from '@spotnana/pixel-react/dist/Button';
import spotnanaTheme from '@spotnana/pixel-react/dist/utils/themes/theme';

export const StyledButton = styled(Button)`
  width: 100%;
  padding: 16px 0px;

  ${spotnanaTheme.mediaQueries.belowDesktop} {
    max-width: 320px;
  }
`;
